<template>
  <qtm-content-block title="Quote Request Items">
    <div class="mb-4">
      <span class="font-weight-bold text-secondary">
        {{ items.length }} total
      </span>
      ({{ itemCount(purchaseItems.length, 'purchase') }}, {{ itemCount(rentalItems.length, 'rental') }})
    </div>
    <purchase-order-items-table
      from-bom
      :boms="boms"
      :items="items"
      :quotes="order?.quotes"
      :show-select-pricing="showSelectPricing"
    />
    <div v-if="order.scope_of_work" class="my-4">
      <span class="font-weight-bold text-secondary">
        Notes for Supplier
      </span>
      <div class="show-newlines" v-text="order.scope_of_work" />
    </div>
    <div v-if="showSelectPricing" class="text-right mt-2">
      <qtm-btn :to="bomLink">
        Select Pricing
      </qtm-btn>
    </div>
  </qtm-content-block>
</template>

<script setup lang="ts">
import type { Order } from '@quotetome/materials-api'
import PurchaseOrderItemsTable from '@/components/purchase-orders/purchase-order-items-table.vue'

export interface Props {
  boms?: any[]
  order: Order
}

const props = withDefaults(defineProps<Props>(), {
  boms: () => [],
})

const bomLink = computed(() => ({ name: 'orders-id-bom-pricing', params: { id: props.order.id } }))
const items = computed<any[]>(() => props.order.skus.map((item, i) => ({ ...item, item_number: i + 1 })))
const purchaseItems = computed(() => items.value.filter(item => !item.rental_duration))
const rentalItems = computed(() => items.value.filter(item => item.rental_duration))
const showSelectPricing = computed(() => {
  const hasPricedQuotes = props.order.quotes.some(q => q.response_received === 'price given')

  return props.order.state.can_select_bom_pricing && hasPricedQuotes
})

const itemCount = (count: number, word: string) => `${count} ${(count === 1 ? word : `${word}s`)}`
</script>
